import React from 'react';

export interface IMapSizes {
  width: number;
  height: number;
}

const MapSizeContext = React.createContext<IMapSizes>({
  width: 1200,
  height: 1100,
});

export default MapSizeContext;
